// Como o cliente chegou até o pedido. O mesmo switch aparecia três vezes em
// PointOfSale.components.tsx, idêntico.

/** Rótulo de tela para o campo `customerOrigin` do cliente. */
export function rotuloDaOrigemDoCliente(customerOrigin: string): string {
  switch (customerOrigin) {
    case "directContact":
      return "Telefone";
    case "externalApp":
      return "Aplicativo externo (Ifood, Rappi...)";
    case "internalApp":
      return "Aplicativo interno (Alfredo, Lucco)";
    default:
      return "Outros";
  }
}
